module.exports = __webpack_public_path__ + "static/joint-evaluation-4c5af51b6ac3d94a7c7ff66dc8757ff8.jpg";